import type { HTMLAttributes, ReactNode } from 'react';
import type { Plan, TenantStatus, UserStatus } from '@titan/shared';
import styles from './Pill.module.css';

export type Tone = 'positive' | 'warning' | 'critical' | 'neutral' | 'premier';

export interface PillProps extends HTMLAttributes<HTMLSpanElement> {
  tone: Tone;
  variant?: 'plain' | 'tier' | 'severity' | 'state';
  children: ReactNode;
}

export function Pill({ tone, variant = 'plain', className, children, ...rest }: PillProps) {
  const cls = [styles.pill, styles[tone], variant !== 'plain' ? styles[variant] : '', className ?? ''].filter(Boolean).join(' ');
  return (
    <span className={cls} {...rest}>
      {children}
    </span>
  );
}

/** Pills never stretch: they always sit inside this flex row wrapper. */
export function PillRow({ children, className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={[styles.row, className ?? ''].filter(Boolean).join(' ')} {...rest}>
      {children}
    </div>
  );
}

export function tenantStatusTone(status: TenantStatus): Tone {
  return status === 'Active' ? 'positive' : status === 'Onboarding' ? 'warning' : 'critical';
}

export function userStatusTone(status: UserStatus): Tone {
  return status === 'Active' ? 'positive' : status === 'Invited' ? 'warning' : 'critical';
}

export function planTone(plan: Plan): Tone {
  return plan === 'Premier' ? 'premier' : plan === 'Advanced' ? 'positive' : 'neutral';
}
